/**
 * SessionList component
 *
 * Scrollable list of user's chat sessions.
 */

import type { Session } from '../../types';
import { SessionItem } from './SessionItem';

interface SessionListProps {
  sessions: Session[];
  currentSessionUuid: string | null;
  onSelectSession: (uuid: string) => void;
  onDeleteSession: (uuid: string) => void;
}

export function SessionList({
  sessions,
  currentSessionUuid,
  onSelectSession,
  onDeleteSession,
}: SessionListProps) {
  if (sessions.length === 0) {
    return (
      <div className="sessions-list" data-testid="sessions-list">
        <div className="empty-sessions">
          <p>Nema sesija</p>
        </div>
      </div>
    );
  }

  return (
    <div className="sessions-list" data-testid="sessions-list">
      {sessions.map((session) => (
        <SessionItem
          key={session.session_uuid}
          session={session}
          isActive={session.session_uuid === currentSessionUuid}
          onSelect={onSelectSession}
          onDelete={onDeleteSession}
        />
      ))}
    </div>
  );
}

export default SessionList;
